<template>
	<el-popover placement="left" width="380" trigger="manual" v-model="visible">
		<div class="accessBox">
			<h3>* 拖动图标放置首页，可更换快捷入口</h3>
			<draggable tag="div" :list="accessDatas" class="quickAccess" group="setItems" forceFallback="true" :disabled="dragDisabled" @end="end"
			 :options="{ghostClass:'ghostClass',fallbackClass:'fallbackClass'}">
				<div v-for="data in accessDatas" :key="data.id">
					<img src="@/assets/img/main/icon-zuzhigoujia.svg" alt="">
					<p>{{data.name}}</p>
				</div>
			</draggable>
			<div id="save">
				<el-button type="primary" @click="onSubmit">确定</el-button>
			</div>
		</div>
		<div slot="reference" style="outline: none;">
			<h2Title title="快捷入口" style="margin-top: 10px;">
				<el-link type="info" class="shortMenu" @click="showPopover()">
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-zidingyishaixuan"></use>
					</svg>自定义入口</el-link>
			</h2Title>
			<draggable tag="div" :list="quickAccess" class="quickAccess" :class="{'showMask':visible}" group="setItems"
			 forceFallback="true" :disabled="dragDisabled" :options="{ghostClass:'ghostClass',fallbackClass:'fallbackClass'}">
				<div v-for="(access,i) in quickAccess" :key="access.id" v-if="i<6" @click="openMenu(i)">
					<img src="@/assets/img/main/icon-zuzhigoujia.svg" alt="">
					<p>{{access.name}} <i v-if="visible" class="el-icon-error" @click.stop="delAccess(i)"></i></p>
				</div>
			</draggable>
		</div>
	</el-popover>


</template>

<script>
	import {
		addQuickEntryR,
		queryQuickEntryList
	} from "@/api/msg/msg";
	import draggable from "vuedraggable";
	import h2Title from "@/page/statistics/template/title.vue";
  import router from "../../../router/router";
  import store from '@/store';
	export default {
		name: "quickAccess",
		props: {
			showMask: {
				type: Boolean,
				default: () => (
					false
				)
			},
		},
		components: {
			h2Title,
		},
		computed: {
			ids() {
				return this.quickAccess.map(item => {
					return item.id
				})
			}
		},
		watch: {
			visible(val, oldVal) { //普通的watch监听
				this.$emit('update:showMask', val);
			},
		},
		data() {
			return {
				visible: false,
				quickAccess: [],
				datas: [],
				entryIds:[],
        menuList: store.getters.pms?store.getters.pms[1]:[] ,
			}
		},
		created() {
			queryQuickEntryList(1).then(res => {
        var newDatas = res.data.data;
				//排除不在菜单列表中的数据
        let operateCodes = this.menuList.map(item => {
          return item.operateCode
        });
        this.datas = newDatas.filter(data =>{
          return operateCodes.indexOf(data.operateCode)!=-1
        });
				this._queryQuickEntryList(true);
			})
		},
		methods: {
			addAccess(data) {
				this.quickAccess.push(data);
			},
			_queryQuickEntryList(isFirst) {
				queryQuickEntryList(2).then(res => {
          var newDatas = res.data.data;
          //排除不在菜单列表中的数据
          let operateCodes = this.menuList.map(item => {
            return item.operateCode
          });
          this.quickAccess = newDatas.filter(data =>{
            return operateCodes.indexOf(data.operateCode)!=-1
          });
					let ids = this.quickAccess.map(item => {
            return item.id
          })
          if(isFirst){
            this.entryIds = ids
          }
          this.accessDatas = this.datas.filter(data =>{
            return ids.indexOf(data.id)<0
          })
				})
			},
			delAccess(i) {
				this.quickAccess.splice(i, 1);
				let ids = this.quickAccess.map(item => {
						return item.id
					})
				this.accessDatas = this.datas.filter(data =>{
					return ids.indexOf(data.id)<0
				})
			},
			showPopover() {
				this.visible = true;
			},
			onSubmit() {
				if(this.ids.join(',') == this.entryIds.join(',')){
            this.visible = false;
						return;
        }
        if(this.ids.length>6){
          this.$message.warning("快捷入口最多选择6个");
          return;
        }
				addQuickEntryR({
					ids: this.ids.join(',')
				}).then(res => {
					if (res.data.code == '0') {
            this.$message.success( "保存成功");

						this.visible = false;
					}
					this._queryQuickEntryList(true);
				});
			},
      end: function (evt) {
        // evt.item //可以知道拖动的本身
        // evt.to    // 可以知道拖动的目标列表
        // evt.from  // 可以知道之前的列表
        // evt.oldIndex  // 可以知道拖动前的位置
        // evt.newIndex  // 可以知道拖动后的位置
        var currentIndex = evt.newIndex;
        if(this.quickAccess.length>6){
          this.$message.warning("快捷入口最多选择6个")
          var that = this;
          setTimeout(function () {
            var currentAccess = that.quickAccess.splice(currentIndex,1);//移除当前元素
            that.accessDatas.push(currentAccess[0]);
          },300)
        }
      },
      //打开路由
      openMenu(i){
			  if(this.visible){
			    return;
        }
			  var _path = this.quickAccess[i].url;
			  if(_path){
          router.push({ path: _path });
        }
      }
		},
	};
</script>

<style scoped>
	.accessBox .quickAccess {
		box-shadow: none;
		height: auto;
		justify-content: flex-start;
	}
	.quickAccess {
		height: 190px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.25);
		border-radius: 4px;
		padding: 10px 0;
		box-sizing: border-box;
		display: flex;
		/* justify-content: space-between; */
		flex-wrap: wrap;

	}

	.showMask {
		position: relative;
		z-index: 10;
	}

	.icon {
		font-size: 53px;
		color: #ccc;
	}

	.quickAccess>div {
		width: 60px;
		display: inline-flex;
    flex-direction: column;
		text-align: center;
		cursor: pointer;
		height: 80px;
		margin: 2px calc(16.5% - 30px) 10px;
	}
  .quickAccess>div img{
    display: inline-block;
    margin: 0 auto 5px;
  }

	.quickAccess p {
		font-size: 14px;
    line-height: 22px;
		text-align: center;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		position: relative;
	}

	.shortMenu>>>.el-link--inner {
		font-size: 13px;
		color: rgba(153, 153, 153, 1);
	}

	.shortMenu>>>.icon {
		margin-right: 8px;
		font-size: 15px;
	}

	.el-link.is-underline:hover:after {
		display: none;
	}

	.accessBox h3 {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 17px;
	}

	#save {
		text-align: center;
		margin-top: 10px;
	}

	#save>>>.el-button {
		background: rgba(255, 134, 121, 1);
	}

	.el-icon-error {
		font-size: 14px;
		color: rgba(199, 199, 199, 1);
		position: absolute;
		top: -60px;
	}
</style>
